const navBtn = document.querySelector('#navBtn');
const nav = document.querySelector('#nav');
const headerSidebar = document.querySelector('#headerSidebar')
const searchTrigger = document.querySelector('#searchTrigger');
const searchForm = document.querySelector('#searchForm');
const subNavTriggers = document.querySelectorAll('.subNavTrigger');

function ariaTrueFalseToggle(item, ariaAttr) {
	// get attribute of item
	let aria = item.getAttribute(ariaAttr);

	// check if attribute is true or false
	if (aria === "true") {
		aria = "false"
	} else {
		aria = "true"
	}

	// set value for attribute
	item.setAttribute(ariaAttr, aria);
}

if (navBtn) {

    navBtn.addEventListener('click', () => {
        navBtn.classList.toggle('is-active');
        nav.classList.toggle('is-active');
		headerSidebar.classList.toggle('hidden');

		ariaTrueFalseToggle(navBtn, 'aria-expanded');
    })
}

// if (subNavTriggers) {

// 	subNavTriggers.forEach( (item) => {
// 		item.addEventListener('click', () => {

// 			ariaTrueFalseToggle(item, 'aria-expanded');

// 			item.classList.toggle('is-active');
// 		})
// 	})
// }

if (searchTrigger) {

	searchTrigger.addEventListener('click', () => {
		searchTrigger.classList.toggle('is-active');
		searchForm.classList.toggle('md:hidden');
	})
}